import { createPermission } from '@backstage/plugin-permission-common';

export const GITHUB_RUNNER_CREATE_PERMISSION = 'github.runner.create';

export const GITHUB_RUNNER_ADMIN_ANNOTATION = "velux.com/github-runners-admin";

export const githubRunnerCreatePermission = createPermission({
    name: GITHUB_RUNNER_CREATE_PERMISSION,
    attributes: { action: 'create' },
});

